export default "__VITE_ASSET__CWaAxaMs__"